import { isEmpty, isNumber, isString } from 'lodash';

export const MAX_PRICE = 1000000000;

/**
 * A function to convert a currency-formatted string to a number.
 * ex. "$5,234,000.00" => 5234000
 *
 * @param {string} price A string with currency formatting
 */
export const convertCurrencyToNumber = (price = '') =>
  parseFloat(`${price}`.replace(/[^0-9.]+/g, ''));

export const formatPrice = (
  price: unknown,
  prependDollarSign = false,
  appendCents = true,
) => {
  const isPriceString = isString(price);
  if (
    !price ||
    (!isPriceString && !isNumber(price)) ||
    (isPriceString && !Number(price.replaceAll(',', '')))
  )
    return `${prependDollarSign ? '$' : ''}0${appendCents ? '.00' : ''}`;

  let result = price.toString();

  const number = convertCurrencyToNumber(result);

  const formatted = number
    ? number.toLocaleString('en', {
        currency: 'usd',
        maximumFractionDigits: appendCents ? 2 : 0,
        minimumFractionDigits: appendCents ? 2 : 0,
      })
    : result;
  result = formatted;

  return `${prependDollarSign ? '$' : ''}${result}`;
};

export const getValidMonetaryString = (currency = '') => {
  const number = convertCurrencyToNumber(currency);
  return Number.isNaN(number) ? '' : number.toFixed(2).toString();
};

export const isCurrencyGreaterThanMaxPrice = (currency = '') =>
  convertCurrencyToNumber(currency) > MAX_PRICE;

export const validRequiredMonetaryPrice = (
  value: number | string,
  fieldName: string,
) => {
  if (fieldName === 'listingPrice') {
    return (
      value !== '0.00' &&
      value !== 0 &&
      !isEmpty(isNumber(value) ? `${value}` : value)
    );
  }

  return !isEmpty(isNumber(value) ? `${value}` : value);
};
